<template>
  <b-container class="mt-5">
    <b-row>
      <b-col>
        <b-card no-body header="Your events">
          <b-list-group flush>
            <b-list-group-item v-for="(event, index) in events" :key="index" :href="`/event/${event.id}`">{{ event.name }} <span class="float-right">{{ event.datetime.fromNow() }} <b-button :href="`/event/${event.id}/edit`" size="sm">Edit</b-button></span></b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import firebase from 'firebase'
import moment from 'moment'
export default {
  data() {
    return {
      events: []
    }
  },
  mounted() {
    firebase.auth().onAuthStateChanged(user => {
      if (!user) return
      firebase.firestore().collection('events').where('organizerId', '==', firebase.auth().currentUser.uid).onSnapshot(ds => {
        this.events = ds.docs.map(d => {
          let evt = d.data()
          evt.datetime = moment(evt.datetime)
          evt.id = d.id
          return evt
        })
      })

    })
  }
}
</script>